import React, { useEffect } from 'react';
import { useParticipantIds, useParticipantProperty, useAudioTrack, useLocalSessionId } from '@daily-co/daily-react';

import { ReactComponent as MicOffIcon } from '../../../../assets/icon/mic-off.svg';
import { ReactComponent as MicOnIcon } from '../../../../assets/icon/mic-on.svg';
import { ReactComponent as CameraOffIcon } from '../../../../assets/icon/camera-off.svg';
import { ReactComponent as CameraOnIcon } from '../../../../assets/icon/camera-on.svg';
import './Participants.css';
import Button from '../../primitives/Button/Button';

const HUDParticipant: React.FC<{ id: string, owner: boolean }> = ({ id, owner }) => {
  const userName: string = useParticipantProperty(id, 'user_name');
  const audioState: string = useParticipantProperty(id, 'tracks.audio.state');
  const videoState: string = useParticipantProperty(id, 'tracks.video.state');

  // TODO: Turn off participant track on button click when owner

  return (
    <div className="participant-row">
      <div className="user-name">{ userName }</div>
      <div className="tracks-container">
        <Button icon={ audioState === 'playable' ? <MicOnIcon /> : <MicOffIcon /> } isClickable={owner} size={'tiny'} />
        <Button icon={ videoState === 'playable' ? <CameraOnIcon /> : <CameraOffIcon /> } isClickable={owner} size={'tiny'} />
      </div>
    </div>
  );
};

const HUDParticipants = () => {
  const participantIds = useParticipantIds();
  const localParticipantId = useLocalSessionId();
  const isLocalOwner = useParticipantProperty(localParticipantId, 'owner');

  return (
    <div className="participants-view">
      { participantIds.map((id) => (
        <HUDParticipant key={id} id={id} owner={isLocalOwner}/>
      ))}
    </div>
  );
};

export default HUDParticipants;
